import {
  Button,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { Xmark } from "iconoir-react"
import { ReactNode } from "react"

type Props = {
  title: string
  // Defaults to `title`. FAQsSheet uses a shorter title on mobile than the desktop heading.
  mobileTitle?: string
  open: boolean
  onClose: () => void
  children: ReactNode
}

const AssignmentDetailSheet = ({
  title,
  mobileTitle,
  open,
  onClose,
  children,
}: Props) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")

  return (
    <Sheet
      open={open}
      onOpenChange={open => {
        if (!open) onClose()
      }}
    >
      <SheetContent
        side={isSmDown ? "bottom" : "right"}
        height={isSmDown ? 95 : 100}
        closeWhenInteractOutside
        className="w-full !max-w-3xl !rounded-t-2xl sm:!rounded-none"
      >
        {isSmDown && (
          <div className="flex items-center justify-between gap-2 px-2.5 pb-3 pt-4">
            <Typography
              className="min-w-0 max-w-xs whitespace-normal break-words"
              variant="title1"
            >
              {mobileTitle ?? title}
            </Typography>

            <IconButton onClick={onClose}>
              <Xmark className="text-onSurface-700" />
            </IconButton>
          </div>
        )}

        <SheetBody className="!px-0 !pb-3">
          {!isSmDown && (
            <Button
              className="mx-3 text-onSurface-900"
              variant="text"
              onClick={onClose}
              startAdornment={<Xmark height={20} width={20} />}
            >
              Close
            </Button>
          )}
          <div className="px-2.5 sm:px-4">
            {!isSmDown && (
              <Typography variant="title3" className="my-2.5">
                {title}
              </Typography>
            )}
            {children}
          </div>
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default AssignmentDetailSheet
